// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"Charities_outerContainer__178Yt","mainContainer":"Charities_mainContainer__3CwXu"};